import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _topicToSubjectMap;
import { ESubject } from '../../../Repositories/feedback-form/entities/feedback/SendFeedbackRequestSchema';
import { EVillageRequestType } from '../../../types/villageRequestType';
var topicToSubjectMap = (_topicToSubjectMap = {}, _defineProperty(_topicToSubjectMap, EVillageRequestType.AddingVillage, ESubject.Kp_creation), _defineProperty(_topicToSubjectMap, EVillageRequestType.EditingVillage, ESubject.Kp_change), _topicToSubjectMap);
var defaultTopic = EVillageRequestType.AddingVillage;
export function prepareVillageRequestTypeSubject(formValue) {
  var topic = formValue.villageRequestType || defaultTopic;
  return topicToSubjectMap[topic] || topicToSubjectMap[defaultTopic];
}